<template>
  <div class="home_wrapper">
    <!-- <v-vedio /> -->
    <v-header :status="true" />
    <div class="banner">
      <el-carousel height="62.5vw">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="banner-content" @click="goBanner(index)">
            <img :src="item.url" :alt="item.alt" class="banner-img" />
            <!-- <el-image :src="item.url" style="width: 100%; height: 100%"  class="banner-img" lazy></el-image> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <img style="width:100%;display: block;" src="../assets/img2/home1_2x.jpg" /> -->
    <iframe
      src="https://b.datav.run/share/840d5cb82623499b9ae709f37ddbe9f4"
      width="100%"
      class="big-scene"
    ></iframe>
    <img
      class="image"
      style="width:100%"
      src="../assets/img2/home_menu_head.png"
    />
    <div class="home-menu-box">
      <img
        @mouseenter="mouseover(item)"
        @mouseleave="selectIndex = -1"
        @click="goMenu"
        :src="
          selectIndex == item
            ? require('../assets/img2/home_menu_' + item + '_selected.png')
            : require('../assets/img2/home_menu_' + item + '_default.png')
        "
        v-for="item in 15"
        :key="item"
        style="cursor: pointer;"
      />
    </div>
    <img
      style="width:100%;margin-top: 80px;"
      src="../assets/img2/home_banner_card.png"
    />
    <div class="card-menue-box">
      <img src="../assets/img2/home_card_menue.png" />
    </div>
    <div style="margin-top:128px;">
      <div style="text-align:center;">
        <img style="width: 331px;" src="../assets/img2/home_news.png" />
      </div>
    </div>

    <div class="news-box">
      <img class="news-bg-box" src="../assets/img2/home_news_bg.png" />
      <div class="" style="z-index: 100;" @click="goNews(0)">
        <img src="../assets/img2/home_news_1.png" />
        <div class="news-content-box">
          <div>艾迪拓二手车大会</div>
          <div style="display:flex;margin-top: 10px;">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div>
              万人见证崛起的新势力，二手车
              行业的新篇章“万象初心创见未来”，承载着二手车行业人回归
              初心的夙愿以及共同探求行业未来发展之道...
            </div>
          </div>
          <div style="text-align: right;">
            <img
              style="display: inline-block;"
              src="../assets/img2/home_arrow_right_default.png"
            />
          </div>
        </div>
      </div>
      <div class="margin20" style="z-index: 100;" @click="goNews(1)">
        <img src="../assets/img2/home_news_2.png" />
        <div class="news-content-box">
          <div>明睿数据冠名山东第一届 “艾迪拓·魔估杯”</div>
          <div style="display:flex">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div>
              2022年11月4日至6日，深圳市明睿数据科技有限公司冠名赞助的“艾迪拓·魔估杯”机动车鉴定与评估大赛在山东省济南市山东劳动职业技术学院成功举办...
            </div>
          </div>
          <div style="text-align: right;">
            <img
              style="display: inline-block;"
              src="../assets/img2/home_arrow_right_default.png"
            />
          </div>
        </div>
      </div>
      <div class="" style="z-index: 100;" @click="goNews(2)">
        <img src="../assets/img2/home_news_3.png" />
        <div class="news-content-box">
          <div>明睿数据荣获广东省 “最具行业创新力企业”</div>
          <div style="display:flex">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div style="position: relative;">
              <div style="text-align:left">
                由广东省汽车流通协会主办的“2022广东省汽车流通行业年会暨高峰论坛”在广州南沙隆重举行。本次年会<img
                  style="float:right;margin-top: 30px;"
                  src="../assets/img2/home_arrow_right_default.png"
                />以“直面变革....
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="margin-top40 " style="z-index: 100;" @click="goNews(3)">
        <img src="../assets/img2/home_news_4.png" />
        <div class="news-content-box">
          <div>把握趋势 全新启程——二手车鉴定评估论坛召开</div>
          <div style="display:flex">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div>
              2021二手车鉴定评估论坛在二手车行业大会期间成功召开来自二手车市场及服务商的代表们针对二手车鉴定评估行业的新技术、新变化、新热点、行业人才培养及“行”认证品牌服务等主题展开交流分享...
            </div>
          </div>
          <div style="text-align: right;">
            <img
              style="display: inline-block;"
              src="../assets/img2/home_arrow_right_default.png"
            />
          </div>
        </div>
      </div>
      <div class="margin-news" style="z-index: 100;" @click="goNews(4)">
        <img src="../assets/img2/home_news_5.png" />
        <div class="news-content-box">
          <div>广东汽协•明睿数据《关于二手车数字化转型的思考》</div>
          <div style="display:flex">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div>
              由广东省汽车流通协会主办的“绿色低碳，赋能创新”广东汽协·汽车后市场沙龙，在广州成功举行，来自全省各地近80家汽车流通企业代表参加...
            </div>
          </div>
          <div style="text-align: right;">
            <img
              style="display: inline-block;"
              src="../assets/img2/home_arrow_right_default.png"
            />
          </div>
        </div>
      </div>
      <div class="margin-top40 " style="z-index: 100;" @click="goNews(5)">
        <img src="../assets/img2/home_news_6.png" />
        <div class="news-content-box">
          <div>明睿数据荣获广东省“优秀汽车后市场企业”</div>
          <div style="display:flex">
            <img
              style="width:19px;display: block;height: 13px;margin-top: 6px;margin-right: 8px;"
              src="../assets/img2/home_arrow_left.png"
            />
            <div style="position: relative;">
              <div style="text-align:left">
                以“直面变革，勇于创新”为主题省市政府相关部门领导、粤港澳地区各大汽车销售集团、二手车经销企业等500<img
                  style="float:right;margin-top: 30px;"
                  src="../assets/img2/home_arrow_right_default.png"
                />多位行业领军人物欢一堂...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
export default {
  name: "Home1",
  components: {
    VHeader,
  },
  data() {
    return {
      bannerList: [
        {
          url: require("../assets/img2/banner4.jpg"),
          alt: "魔估二手车X3Pro/S3Pro",
        },
        {
          url: require("../assets/img2/banner3.jpg"),
          alt: "魔估二手车X2Pro/S2Pro",
        },
        {
          url: require("../assets/img2/banner1_2x.png"),
          alt: "明睿数据",
        },
        {
          url: require("../assets/img2/banner2_2x.jpg"),
          alt: "车联网PAAS平台",
        },
      ],
      originUrl: "",
      selectIndex: -1,
      newsList: [
        "https://www.yoojia.com/article/10228301746062355642.html",
        "https://baijiahao.baidu.com/s?id=1749099421459055278&wfr=spider&for=pc",
        "https://view.inews.qq.com/a/20220608A06HIJ00",
        "https://new.qq.com/rain/a/20210726A08SNU00",
        "https://www.sohu.com/a/550211665_120368407",
        "https://view.inews.qq.com/a/20220608A06JPL00",
      ],
    };
  },
  mounted() {
    this.originUrl = document.location.origin;
  },
  methods: {
    goUrl(url, type) {
      switch (type) {
        case "inner":
          this.$router.push({ path: url });
          break;
        case "outer":
          window.open(url);
          break;
      }
    },
    goNews(index) {
      window.open(this.newsList[index]);
    },
    goBanner(index) {
      this.$router.push({ path: index < 3 ? "/aidtools" : "/x431mr" });
    },
    goMenu() {
      this.$router.push({
        path: "aidtools",
        query: {
          hashId: "menu-box",
        },
      });
    },
    mouseover(index) {
      this.selectIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
div.home_wrapper {
  position: relative;
  min-width: 1420px;
  margin: 0 auto;
  > div.banner {
    /deep/.el-carousel__container {
      position: relative;
      height: 1200px;
    }
    /deep/ .el-carousel__indicator .el-carousel__button {
      background: #dddddd !important;
    }
    /deep/ .el-carousel__indicator.is-active button {
      background: white !important;
    }
    div.banner-content {
      width: 100vw;
      > img {
        width: 100%;
        display: block;
      }
    }
  }
  > img.image {
    width: 100%;
    display: block;
  }
  > div.news {
    position: relative;
    width: 1400px;
    margin: 120px auto;
    > div:first-child {
      text-align: center;
      height: 66px;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 66px;
      color: #131415;
      opacity: 1;
    }
    > div:last-child {
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      > div {
        position: relative;
        width: 680px;
        cursor: pointer;
        &:hover {
          > div:first-child {
            > img {
              transform: scale(1.1);
            }
          }
        }
        > div:first-child {
          width: 660px;
          overflow: hidden;
          > img {
            width: 100%;
            transition: all 0.6s;
            display: block;
          }
        }
        > div:last-child {
          position: relative;
          padding: 25px;
          width: 660px;
          background: #f7f7f7;
          box-sizing: border-box;
          > div:nth-child(1) {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 30px;
            color: #333333;
            opacity: 1;
          }
          > div:nth-child(2) {
            text-indent: 28px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 30px;
            color: #333333;
            opacity: 1;
            margin-top: 14px;
          }
          > div:nth-child(3) {
            height: 24px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: #333333;
            opacity: 1;
            margin-top: 40px;
          }
        }
      }
    }
    > div + div {
      margin-top: 120px;
    }
  }
}
.news-box {
  // background-image: url("../assets/img2/home_news_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1465px;
  margin: 0 auto;
  margin-top: 70px;
  position: relative;
  margin-bottom: 120px;
  img:first-child {
    width: 468px;
    display: block;
  }
}
.news-content-box {
  background: white;
  width: 416px;
  margin: 0 auto;
  margin-top: -50px;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0px 0px 59px 0px rgba(12, 62, 185, 0.08);
  border-radius: 3px;
  position: relative;
  > div:first-child {
    color: #232323;
    font-size: 28px;
    text-align: left;
    font-weight: bold;
  }
  > div:nth-child(2) {
    margin-top: 20px;
    color: #626262;
    font-size: 16px;
  }
  > div:last-child {
    text-align: right;
    img {
      width: 29px;
      height: 29px;
    }
  }
}
/deep/ .el-carousel__indicators--horizontal {
  bottom: 60px !important;
}
.width-200 {
  width: 200px;
}
.margin20 {
  margin: 0px 30px;
}
.margin-top40 {
  margin-top: 40px;
}
.margin-news {
  margin: 80px 30px 0px 30px;
}
.card-menue-box {
  width: 100%;
  margin-top: -80px;
  text-align: center;
  img {
    width: 1540px;
  }
}
.home-menu-box {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  margin-top: -200px;
  width: 1002px;
  img {
    width: 200px;
    display: block;
  }
}
.news-bg-box {
  position: absolute;
  top: 400px;
  left: calc(50% - 620px);
  width: 1240px !important;
  height: 643px !important;
  z-index: 0;
}
.big-scene {
  height: 56.25vw;
}
</style>
